import TableStructure from 'common/TableStructure';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { useAuth } from 'context/AuthContext';

import React, { useState } from 'react';

import ServicePopup from './ServicePopup';

export const GridContainer = styled.div`
    width: 100%;
    overflow-x: auto;
    
    @media (min-width: 768px) {
        overflow-x: visible;
    }
`;

export default function ServiceTable({ rows, getServiceList }) {
    const { token } = useAuth();
    const [openPopup, setOpenPopup] = useState(false);
    const [editRowData, setEditRowData] = useState({});

    const togglePopup = (params) => {
        setEditRowData(params);
        setOpenPopup(!openPopup);
    };


    const handleDelete = async (row) => {
        
        let confirmDelete = window.confirm('Are you sure you want to delete this service?');

        if (!confirmDelete) {
            return;
        }

        try {
            if (!token) {
                console.error('No authentication token found');
                return;
            }

            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/api/providers/services`,
                {
                    method: 'DELETE',
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${token}`,
                    },
                    body: JSON.stringify({
                        id: row.id,
                        business_id: row.business_id,
                    }),
                }
            );

            if (response.ok) {
                handleSuccess();
            } else {
                const result = await response.json().catch(() => ({}));
                console.error('Error deleting service:', result.error || 'Failed to delete service');
            }
        } catch (err) {
            console.error('Error deleting service:', err);
        }
    };

    const handleSuccess = () => {
        getServiceList().then();
    };

    const columns = [
        {
            field: 'id',
            headerName: <FormattedMessage id="be.seen.invoice.table.date" defaultMessage="ID" />,
            flex: 0.3,
            minWidth: 60,
        },
        {
            field: 'name',
            headerName: <FormattedMessage id="be.seen.invoice.table.name" defaultMessage="Name" />,
            flex: 1,
            minWidth: 120,
        },
        {
            field: 'description',
            headerName: <FormattedMessage id="be.seen.invoice.table.description" defaultMessage="Description" />,
            flex: 1.5,
            minWidth: 180,
        },
        {
            field: 'price',
            headerName: 'Price',
            flex: 0.6,
            minWidth: 80,
            renderCell: (params) => {
                return params.row.price ? `$${parseFloat(params.row.price).toFixed(2)}` : '-';
            },
        },
        {
            field: '',
            headerName: '',
            sortable: false,
            flex: 0.3,
            minWidth: 50,
            renderCell: (params) => {
                return (
                    <svg
                        width="18"
                        height="18"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        style={{
                            cursor: 'pointer',
                            marginLeft: 'auto',
                            marginRight: '12px',
                        }}
                    >
                        <path
                            d="M9 18L15 12L9 6"
                            stroke="#666666"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                );
            },
        },
    ];
    return (
        <>
            <GridContainer>
                <TableStructure rows={rows} columns={columns} handleRowClick={togglePopup}></TableStructure>
            </GridContainer>

            <ServicePopup
                open={openPopup}
                onClose={togglePopup}
                serviceData={editRowData}
                getServiceList={getServiceList}
                handleDelete={handleDelete}
            ></ServicePopup>
        </>
    );
}
